module.exports = __webpack_public_path__ + "img/1.9010e516.png";